import { visibleWizardSteps } from '../constants/wizardSteps';

export const validateStep = (stepId, form) => {
  const errors = {};

  switch (stepId) {
    case 'basic': {
      if (form.eventType === 'ACTION_TRACKING') {
        if (!form.name?.trim()) errors.name = 'Tracker name is required';
        const trackKind = String(form.configuration?.trackKind || '').toUpperCase();
        if (trackKind !== 'COUNT' && trackKind !== 'NUMBER') {
          errors.trackKind = 'Pick how you wanna track';
        }
        if (form.configuration?.actionShare) {
          if ((form.participants?.required || []).length < 2) {
            errors.participants = 'Add someone to share with, or keep it for self';
          }
        }
        break;
      }
      if (form.eventType === 'POLL') {
        const question = form.responsePolicy?.pollQuestion?.trim() || form.name?.trim();
        if (!question) errors.pollQuestion = 'Poll text is required';
        const opts = (form.responsePolicy?.pollOptions || []).filter((o) => o?.trim());
        if (opts.length < 2) errors.pollOptions = 'Add at least two options';
        const mode = form.participants?.mode;
        if (mode !== 'EVERYONE' && mode !== 'ADMINS_ONLY' && mode !== 'DM_AUTO') {
          const required = form.participants?.required || [];
          if (required.length < 2) {
            errors.participants = 'Choose which participants you want to send this poll to';
          }
        }
        break;
      }
      if (!form.name?.trim()) errors.name = 'Event name is required';
      if (!form.eventType) errors.eventType = 'Select an event type';
      if (!form.responsePolicy?.type) errors.responseType = 'Select a response type';
      if (form.eventType === 'ATTENDANCE' && form.responsePolicy?.type === 'NONE') {
        errors.responseType = 'Invitations need a response type';
      }
      const rt = form.responsePolicy?.type;
      if (rt === 'POLL' || rt === 'MULTIPLE_CHOICE') {
        if (!form.responsePolicy?.pollQuestion?.trim()) {
          errors.pollQuestion = 'Poll question is required';
        }
        const opts = (form.responsePolicy?.pollOptions || []).filter((o) => o?.trim());
        if (opts.length < 2) errors.pollOptions = 'Add at least two options';
      }
      if (form.eventType === 'EXPENSE_TRACKING') {
        const fields = form.configuration?.fields || {};
        const anyEnabled = Object.values(fields).some((f) => f && f.enabled !== false);
        if (Object.keys(fields).length && !anyEnabled) {
          errors.eventType = 'Enable at least one expense field';
        }
      }
      const { schedule } = form;
      const scheduleOptional = form.eventType === 'SPLITWISE';
      const hasSchedule = Boolean(
        schedule?.startDate || schedule?.endDate || schedule?.startTime || schedule?.endTime,
      );
      if (!scheduleOptional || hasSchedule) {
        if (!scheduleOptional) {
          if (!schedule?.startDate) errors.startDate = 'Start is required';
          if (!schedule?.allDay) {
            if (!schedule?.startTime) errors.startTime = 'Start is required';
            if (!schedule?.endTime) errors.endTime = 'End is required';
          }
        }
        if (!schedule?.allDay) {
          const startAt = `${schedule.startDate || ''}T${(schedule.startTime || '').slice(0, 5)}`;
          const endAt = `${schedule.endDate || schedule.startDate || ''}T${(schedule.endTime || '').slice(0, 5)}`;
          if (schedule?.startTime && schedule?.endTime && endAt <= startAt) {
            errors.endTime = 'End must be after start';
          }
        } else if (schedule?.endDate && schedule.startDate && schedule.endDate < schedule.startDate) {
          errors.endTime = 'End must be on or after start';
        }
      }
      break;
    }

    case 'participants': {
      if (form.eventType === 'POLL' && (form.participants?.mode === 'EVERYONE' || form.participants?.mode === 'ADMINS_ONLY' || form.participants?.mode === 'DM_AUTO')) break;
      const required = form.participants?.required || [];
      if (required.length === 0) errors.participants = 'Add at least one required participant';
      const max = Number(form.participants?.maxParticipants);
      const min = Number(form.participants?.minParticipants);
      if (max > 0 && min > 0 && min > max) {
        errors.minParticipants = 'Minimum cannot exceed maximum';
      }
      break;
    }

    case 'rules':
      break;

    case 'notifications':
      break;

    case 'completion':
      break;

    case 'attachments':
      break;

    case 'review':
      break;

    default:
      break;
  }

  return { valid: Object.keys(errors).length === 0, errors };
};

export const validateAllSteps = (form) => {
  const steps = visibleWizardSteps(form);
  for (const step of steps) {
    if (step.id === 'review') continue;
    const result = validateStep(step.id, form);
    if (!result.valid) return { valid: false, stepId: step.id, errors: result.errors };
  }
  return { valid: true, errors: {} };
};
